module.exports = {
      id: "hide-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#hide-usage",
      toString: function () {
        return this.url;
      }
    }